import { removeItem } from ".";
import { handleCustomPanelSelection } from "./customPanelSelection";
import { handleDiscountPanelSelection } from "./discountPanelSelection";
import { getAllDescendants, getTestNode, handleTestSelection } from "./testSelection";
import { handleXChooseYSelection } from "./xChooseYPanelSelection";

export function addSelectedShortcut(shortcutId, selectProp, supportObj) {
  let { selectedShortcutIdList } = supportObj;
  // select contents in current shortcut
  handleShortcutSelection(shortcutId, selectProp, true, supportObj);
  // add shortcut to selected list
  selectedShortcutIdList.push(shortcutId);
  // remove test and panels in shortcut from selected tests
  removeTestAndPanel(shortcutId, supportObj);
}

export function removeSelectedShortcut(shortcutId, selectProp, supportObj) {
  let { selectedShortcutIdList } = supportObj;
  // de-select contents in current shortcut
  handleShortcutSelection(shortcutId, selectProp, false, supportObj);
  // remove shortcut from selected list
  removeItem(shortcutId, selectedShortcutIdList);
  if (selectProp === "isSelect") {
    // remove shortcut from edit order list if any
    removeShortcutInEditOrder(shortcutId, supportObj);
  }
}

export function handleShortcutSelection(shortcutId, selectProp, isSelectShortcut, supportObj) {
  let { shortcutList, testNodeList, bundleList } = supportObj;
  let shortcut = shortcutList.find(s => s.id === shortcutId);
  if (!shortcut) {
    return;
  }
  shortcut[selectProp] = isSelectShortcut;
  // select/de-select tests that included in this shortcut
  let { testIdList, discountPanelIdList, customPanelIdList, selectedXChooseYPanelList } = shortcut;
  let testNodes = testNodeList.filter(node => testIdList.includes(node.id) || testIdList.includes(node.value.originalId));
  testNodes.forEach(node => {
    handleTestSelection(node, selectProp, isSelectShortcut);
  });
  // select/de-select discount panels( and its tests ) that included in this shortcut
  discountPanelIdList.forEach(panelId => {
    handleDiscountPanelSelection(panelId, selectProp, isSelectShortcut, supportObj);
  });

  // select/de-select custom panels
  customPanelIdList.forEach(panelId => {
    handleCustomPanelSelection(panelId, selectProp, isSelectShortcut, supportObj);
  });

  // select/de-select xChooseY panels that included in this shortcut if any
  if (selectedXChooseYPanelList) {
    selectedXChooseYPanelList.filter(p => !p.customPanelId).forEach(panel => {
      let foundPanel = bundleList.find(p => p.bundleId === panel.bundleId);
      foundPanel.selectedZoomerIdList = panel.selectedZoomerIdList;
      foundPanel.zoomerList = panel.zoomerList;
      foundPanel.selectedSupplementIdList = panel.selectedSupplementIdList;
      handleXChooseYSelection(panel.bundleId, selectProp, isSelectShortcut, supportObj);
    });
  }
}

function removeTestAndPanel(shortcutId, supportObj) {
  let { shortcutList } = supportObj;
  let shortcut = shortcutList.find(s => s.id === shortcutId);
  let { 
    testIdList, 
    discountPanelIdList, 
    customPanelIdList, 
    xChooseYIdList 
  } = shortcut;
  // remove shortcut's test and descendants
  testIdList.forEach(id => { 
    removeTestAndItsDescendants(id, supportObj);
  });
  // remove shortcut's discount panel and descendants
  discountPanelIdList.forEach(id => { 
    removeDiscountPanelAndItsContent(id, supportObj);
  });
  // remove shortcut's xChooseY panel
  xChooseYIdList.map(item => item.bundleId).forEach(id => {
    removeXChooseYPanelAndItsContent(id, supportObj);
  });
  // remove shortcut's xChooseY panel
  xChooseYIdList.map(item => item.bundleId).forEach(id => {
    removeXChooseYPanelAndItsContent(id, supportObj);
  });
  // remove shortcut's custom panel
  customPanelIdList.forEach(id => { 
    removeCustomPanelAndItsContents(id, supportObj);
   });
}

function removeTestAndItsDescendants(testId, supportObj) {
  let { testNodeList, selectedTestIdList } = supportObj;
  removeItem(testId, selectedTestIdList);
  let root = getTestNode(testNodeList, testId);
  let descendants = [];
  getAllDescendants(root, descendants);
  descendants.map(d => d.id).forEach(id => {
    removeItem(id, selectedTestIdList);
  });
}

function removeDiscountPanelAndItsContent(panelId, supporObj) {
  let { selectedDiscountPanelIdList, bundleList } = supporObj;
  removeItem(panelId, selectedDiscountPanelIdList);
  let discountPanel = bundleList.find(b => b.bundleId === panelId);
  // select all package and test belong to this panel
  let idList = discountPanel.bundleContent.packageList.map(p => p.packageId)
    .concat(discountPanel.bundleContent.testList.map(t => t.testId));
  idList.forEach(testId => {
    removeTestAndItsDescendants(testId, supporObj);
  })
}

function removeXChooseYPanelAndItsContent(panelId, supporObj) {
  let { selectedDiscountPanelIdList, bundleList } = supporObj;
  removeItem(panelId, selectedDiscountPanelIdList);
  let xChooseYPanel = bundleList.find(b => b.bundleId === panelId);
  if (xChooseYPanel) {
    let { selectedZoomerIdList, selectedSupplementIdList } = xChooseYPanel;
    let testIdList = (selectedZoomerIdList ? selectedZoomerIdList : [])
      .concat(selectedSupplementIdList ? selectedSupplementIdList : []);
    testIdList.forEach(id => {
      removeTestAndItsDescendants(id, supporObj);
    });
  }
}

function removeCustomPanelAndItsContents(panelId, supportObj) {
  let { selectedCustomPanelIdList, bundleList } = supportObj;
  removeItem(panelId, selectedCustomPanelIdList);
  let customPanel = bundleList.find(b => b.bundleId === panelId);
  if (customPanel) {
    customPanel.bundleItemList.forEach(content => {
      if (content.itemType === "official bundle") {
        if (content.itemId) {
          let panel = bundleList.find(b => b.bundleId === content.itemId);
          if (panel.category === "discountPanel") {
            removeDiscountPanelAndItsContent(panel.bundleId, supportObj);
          } else if (panel.category === "xChooseY") {
            removeXChooseYPanelAndItsContent(panel.bundleId, supportObj);
          }
        }
      }
      else { // remove test
        if (content.itemId) {
          removeTestAndItsDescendants(content.itemId, supportObj);
        }
      }
    });
  }
}

function removeShortcutInEditOrder(shortcutId, supportObj) {
  let { editOrderItemList } = supportObj;
  let shortcut = editOrderItemList.find(item => item.item_id === shortcutId && item.category === "shortcut");
  removeItem(shortcut, editOrderItemList);
}